<template lang="html">
  <div class="modal-bg">
    <div class="modal modal--prompt">
      <h4 class="modal-title">
        {{ mainTitle }}
      </h4>
      <p class="modal-text text">
        {{ subTitle }}
      </p>
      <button-component :class="yesButtonColorClass" block @click="onConfirm">
        {{ yesTitle }}
      </button-component>
      <a class="modal-continue" href="#" @click.prevent="onCancel">
        {{ noTitle }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ButtonComponent from "./ButtonComponent.vue"

interface ConfirmModalProps {
  mainTitle: string
  subTitle: string
  yesTitle: string
  noTitle: string
  yesButtonColorClass: string
}

withDefaults(defineProps<ConfirmModalProps>(), {
  mainTitle: "Are you sure?",
  subTitle: "Are you sure?",
  yesTitle: "Yes",
  noTitle: "No",
  yesButtonColorClass: ""
})

const emit = defineEmits(["confirm", "cancel"])

const onConfirm = () => {
  emit("confirm")
}

const onCancel = () => {
  emit("cancel")
}
</script>
